import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import colors from '@app/theme/colors';
import font from '@app/theme/fonts';

import { TAG_TYPE } from '@components/Tag';
import Price from '../../components/Price';

const PROPS = {
  product: PropTypes.object,
  trackBeforePriceProductsLoaded: PropTypes.func.isRequired,
};

const BEFORE_PRICE = 'beforePrice';
const MINIMUM_PORCENTAGE = 5;

export default function WithBeforePrice(T) {
  return class WithBeforePriceFn extends PureComponent {
    static propTypes = PROPS;

    getPrecentage({ price, beforePrice }) {
      return beforePrice !== undefined
        ? Math.round(100 - (price * 100) / beforePrice)
        : null;
    }

    getBeforePrice() {
      const { product } = this.props;
      if (product.campaigns && product.campaigns.length > 0) {
        const beforePriceCampaign = product.campaigns.filter(
          campaign => campaign.type === BEFORE_PRICE,
        );
        if (beforePriceCampaign.length > 0) {
          return beforePriceCampaign[0].value;
        }
      }
      return null;
    }

    getBeforePriceDiscounTag(price, beforePrice) {
      return [
        {
          bgColor: colors.blue_lighter_2,
          text: {
            color: colors.blue_darker_3,
            font: font.xxSmallBold,
            text: `${this.getPrecentage({ price, beforePrice })}% OFF`,
          },
          type: TAG_TYPE.DEALS,
        },
      ];
    }

    render() {
      const {
        product: { priceWithDiscount, price, businessType, subsidizedProduct },
      } = this.props;
      const beforePrice = this.getBeforePrice();
      const percentageDiscount = this.getPrecentage({ price, beforePrice });
      const validBeforePrice = !!(
        beforePrice !== null && percentageDiscount >= MINIMUM_PORCENTAGE
      );
      if (validBeforePrice) {
        return (
          <T
            {...this.props}
            groceriesPrice={
              <Price
                price={this.getBeforePrice()}
                businessType={businessType}
                priceWithDiscount={price}
                subsidizedProduct={subsidizedProduct}
              />
            }
          />
        );
      }

      return (
        <T
          {...this.props}
          groceriesPrice={
            <Price
              price={price}
              businessType={businessType}
              priceWithDiscount={priceWithDiscount}
              subsidizedProduct={subsidizedProduct}
            />
          }
        />
      );
    }
  };
}
